import {
  DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
  DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
} from 'common/components';
import { CABINET_LANDING_NAME } from '../../cabinet-constants';
import { ALL_IMAGE_LIST_PRESET } from './cabinet-gallery-constants';
import { CabinetImageStructure, ImagePreset } from './cabinet-gallery-types';

const prepareImageList = (imagePresetList: ImagePreset[]): CabinetImageStructure[] => (
  imagePresetList.map((preset, index: number) => {
    const subPath = index === 0 ? `large-card/${preset.style}` : preset.style;

    return {
      alt: preset.displayedName,
      name: preset.displayedName,
      addText: preset.addText,
      src: `${CABINET_LANDING_NAME}/gallery/${preset.style}/${preset.mediaMainPhoto}`,
      srcSmall: `${CABINET_LANDING_NAME}/gallery/${subPath}/${preset.mediaMainPhoto}`,
      transformations: index === 0 ? DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS : DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
    }
  })
);

export const getImageList = (style: string) => {
  if (style === 'all') {
    return prepareImageList([...ALL_IMAGE_LIST_PRESET]
      .filter(preset => Boolean(preset.rating))
      .sort((a, b) => {
        if (a.rating === undefined && b.rating === undefined) return 0;
        else if (a.rating === undefined) return 1;
        else if (b.rating === undefined) return -1;
        else return a.rating - b.rating;
      }))
  }

  return prepareImageList(ALL_IMAGE_LIST_PRESET.filter(preset => preset.style === style));
}